/**
 * Whether PGM Progress Surfaces should hide next-level purchase /
 * membership-election Apply CTAs while Acceptable Progress Termination
 * still blocks advancement.
 *
 * Curriculum (default): only suppress when `account-terminated-notice` is on
 * and standing is Reapply-Gated (`showReapplyPathOffer`). Progress-Privileged
 * Curriculum CTAs stay intact when the flag is off.
 *
 * Journey (`standingScoped: true`): suppress whenever standing blocks next-
 * level purchase (Progress-Privileged or Reapply-Gated). Pass this only from
 * Journey callers, and only when `account-terminated-notice` is on.
 */
export function shouldSuppressAdvancementCtas({
  standing,
  isTerminatedNoticeEnabled,
  standingScoped = false,
}) {
  if (standingScoped) {
    return standing?.allowNextLevelPurchase === false
  }

  return !!isTerminatedNoticeEnabled && !!standing?.showReapplyPathOffer
}

/**
 * Terminated GPTP / Curriculum APT copy while Progress-Privileged or
 * Reapply-Gated. Flag-off restores pre-gate suspension / "not current" copy.
 */
export function shouldUseTerminatedGptpCopy({
  isTerminatedNoticeEnabled,
  standing,
}) {
  return !!isTerminatedNoticeEnabled && !!standing?.showProgressStandingNotice
}

const CURRICULUM_REAPPLY_CTA_STATUSES = new Set(["open", "denied"])

/**
 * Classic Course Curriculum Reapply CTA: same Open/Denied applications link
 * as Journey's Reapply card. Progress-Privileged (level unfinished) stays
 * message-only. Do not use this for path-specific Become Associate/Affiliate.
 */
export function shouldShowCurriculumReapplyCta({
  isTerminatedNoticeEnabled,
  standing,
  reapplyStatus,
}) {
  return (
    !!isTerminatedNoticeEnabled &&
    !!standing?.showReapplyPathOffer &&
    CURRICULUM_REAPPLY_CTA_STATUSES.has(reapplyStatus)
  )
}
